document.addEventListener("DOMContentLoaded", function() {
    // 커스텀 Sticky Bar
    const sections = document.querySelectorAll('.custom-section-content');
    if (sections.length > 0) {
    const customStickyBar = sections[sections.length - 1];
    customStickyBar.classList.add('custom-sticky-bar');
    window.addEventListener('scroll', function() {
        if (window.scrollY > 50) {
        customStickyBar.classList.add('is-active');
        } else {
        customStickyBar.classList.remove('is-active');
        }
    });
    }
    const headers = document.querySelectorAll('h1');
    if (headers.length > 0) {
        const header = headers[0];
        header.id = 'header';
    }
});